import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-items-dublicate',
  standalone: true,
  imports: [MatCheckbox, CommonModule, FormsModule],
  templateUrl: './items-dublicate.component.html',
  styleUrls: ['./items-dublicate.component.scss'],
})
export class ItemsDublicateComponent {
  @Input() duplicatedLeads: any[] | any; // Accept array or single object
  @Output() primaryChanged = new EventEmitter<any>();

  selectPrimary(selectedLead: any) {
    if (Array.isArray(this.duplicatedLeads)) {
      this.duplicatedLeads.forEach((lead) => {
        lead.isPrimary = lead === selectedLead;
      });
      this.primaryChanged.emit(this.duplicatedLeads);
    }
  }

  isArray(data: any): boolean {
    return Array.isArray(data);
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Date';
    
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  }
}